module.exports = __webpack_public_path__ + "img/bug_fixed.93cab61a.png";